import { Container, IContainer, ContainerType } from "./Container";
import { IPeriod, Period } from "./Period";


export enum StatusZlecenia {
    W_PLANOWANIU_DRUKU = "W Planowaniu Druku",
    ZAPLANOWANY_DRUK = "Zaplanowany Druk",
    W_DRUKU = "W Druku",
    
    W_PLANOWANIU_PRZEWIJANIA = "W Planowaniu Przewijania",
    ZAPLANOWANE_PRZEWIJANIE = "Zaplanowane Przewijanie",
    W_PRZEWIJANIU = "W Przewijaniu",
  }
  


export interface IJob extends IPeriod {
    _id: string
    name: string
    status: StatusZlecenia
  
    duration: number;
    startTime: Date;
    endTime: Date;
    added_duration:number
  
    formatted_start:string
    formatted_end:string
  
    planNrMaszynyDrukujacej:number | undefined
    planNrPrzewijarki:number| undefined
  
    rzeczywNrMaszynyDrukujacej:number| undefined
    rzeczywNrPrzewijarki:number| undefined
  
    overlaps(period: IPeriod): boolean 
  }

  export class Job extends Container implements IContainer, IJob, IPeriod {

    duration: number;
    startTime: Date = new Date();
    endTime: Date = new Date();

    formatted_start=""
    formatted_end=""

    added_duration: number=0;
    text:string=""


    planNrMaszynyDrukujacej:number | undefined
    planNrPrzewijarki:number| undefined

    rzeczywNrMaszynyDrukujacej:number| undefined
    rzeczywNrPrzewijarki:number| undefined

  
    constructor(parents_:IContainer[], private status_: StatusZlecenia, startTime:Date, duration: number) {
      super(parents_,ContainerType.Zlecenie)
      
      this.startTime = startTime
      this.endTime = Period.add_minutes(this.startTime,duration);

      this.duration = duration;

      this.formatted_start = Period.format_date(this.startTime)+' '+Period.format_hour(this.startTime)
      this.formatted_end   = Period.format_date(this.endTime)+' '+Period.format_hour(this.endTime)
    }

    get status() { return this.status_}
    
    add_job(job: Job) {
      job.parents.push(this)
      this.children.push(job)
    }
    
    overlaps(period: IPeriod): boolean {
      return ( (this.startTime <= period.endTime && this.endTime >= period.startTime) || (period.startTime <= this.endTime && period.endTime >= this.startTime));
    }

  }
